// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"50":"b956bf142d783ea69a18","104":"1174c880ae6d6c9ca811","179":"46b43be9b17b20a21c51","180":"fed0bdf44fef5bb43c23","250":"99edc8d1c252059100d6","341":"a2bdc21ea3645d43e0f8","384":"9928bb201654c8f38660","894":"44a5c08d22d9be2ed9f4"}[chunkId] + ".js";
};